import Transporter from "./class.Transporter.js";
import * as TransporterUtils from "./class.TransporterUtils.js";
import colors from "./colors.js";

AoPS.Utils.initKeyChain(AoPS, "Transporter");

AoPS.Transporter.Main = Transporter;
AoPS.Transporter.Utils = TransporterUtils;
AoPS.Transporter.Colors = colors;
